import styled, { keyframes, css } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

export const charBubbleAnimation = keyframes`
    0%, 100% { 
        transform: scale(1); 
        opacity: 1;
    }
    50% { 
        transform: scale(1.3); 
        opacity: 0.7;
    }
`;

export const HeaderContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 56px;
    padding-top: ${({ theme }) => theme.spacing.medium};
`;

export const HeaderText = styled(Text)<{ shouldAnimateChars?: boolean }>`
    position: relative;
    display: block;
    padding-left: ${({ theme }) => theme.spacing.medium};
    margin-top: auto;
    .char {
        display: inline-block;
        will-change: transform;
    }
    ${(props) =>
        props.shouldAnimateChars &&
        css`
            .char {
                animation: ${charBubbleAnimation} 0.6s ease-in-out;
                animation-delay: calc(0.05s * var(--char-index));
                transform-origin: center;
                animation-fill-mode: forwards;
                animation-iteration-count: 1;
            }
        `}
`;

export const TitleRowWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: ${({ theme }) => theme.spacing.medium};
    padding-right: ${({ theme }) => theme.spacing.medium};
    margin-top: ${({ theme }) => theme.spacing.xxxSmall};
    margin-bottom: ${({ theme }) => theme.spacing.xxSmall};
`;

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;

    & > div {
        display: flex;
    }
`;

export const HeaderLottieContainer = styled.div({
    position: "absolute",
    height: "100%",
    top: 0,
    left: 0,
    paddingLeft: "0 !important",
    willChange: "transform",
    transform: "translateZ(0)",
});

export const MagicItemsHeaderContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const MagicItemsIcon = styled(Image)`
    display: inline-block;
    vertical-align: middle;
`;

export const LockedHeaderIcon = styled(Image)`
    margin-top: ${({ theme }) => `calc(-1 * ${theme.spacing.xxxSmall})`};
    object-fit: cover;
`;

export const MagicItemsHeaderWrapper = styled.div<{ hasTopPadding?: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: ${({ theme, hasTopPadding }) =>
        hasTopPadding
            ? `${theme.spacing.small} ${theme.spacing.small} 0 ${theme.spacing.medium}`
            : `0 ${theme.spacing.medium}`};
    margin-bottom: ${({ theme, hasTopPadding }) =>
        hasTopPadding ? `calc(-1 * (${theme.spacing.xSmall} + ${theme.spacing.xxxSmall}))` : 0};
`;

export const MagicItemsTitle = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xxxSmall};
`;

export const TimerContainer = styled.div<{ isUrgent?: boolean }>`
    padding: ${({ theme }) => `${theme.spacing.xxxSmall} ${theme.spacing.xSmall}`};
    border-radius: ${({ theme }) => theme.cornerRadius.large};

    display: flex;
    align-items: center;
`;

export const MagicItemsText = styled(Text)`
    font-weight: 900;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors[theme.colorMode].surprise_Deals_Primary};
    margin: 0;
    padding: 0;

    & > div {
        display: flex;
        align-items: center;
        gap: ${({ theme }) => theme.spacing.xxSmall};
    }
`;

export const LockedHeaderContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => `calc(${theme.spacing.xxSmall} + ${theme.spacing.xxxSmall})`};

    padding: ${({ theme }) => `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.xSmall}`};
`;

export const LockedTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;

export const LockedMessageText = styled(Text)`
    @media (max-width: 380px) {
        ${({ theme }) => theme.typography["V2.body3.neutral.bold"]}
    }
`;

// It is because we are using replaceText so in order to change the CSS for container inside
// to align image & text correctly we have to use nested div and img selectors.
export const EOMessageWrapper = styled.div<{ backgroundColor?: string }>`
    padding: ${({ theme }) => theme.spacing.x5};
    border-radius: ${({ theme }) => `calc(${theme.spacing.x6} + 1px) calc(${theme.spacing.x6} + 1px) 0 0`};
    background: ${({ backgroundColor }) =>
        backgroundColor || "linear-gradient(90deg, var(--container-background-tertiary, #f6f6f9) 0.12%, #fff 88.03%)"};
    width: auto;
    height: ${({ theme }) => `calc(${theme.spacing.x16} + ${theme.spacing.xxxSmall} + 1px)`};
    margin: ${({ theme }) => `${theme.spacing.xxSmall} ${theme.spacing.xxSmall} 1px ${theme.spacing.xxSmall}`};

    & > div {
        color: ${({ theme }) => theme.colors[theme.colorMode].text_Low_Emphasis};
        ${({ theme }) => theme.typography["V2.body3.neutral.medium"]}

        display: flex;
        gap: ${({ theme }) => theme.spacing.xxSmall};
        align-items: center;
    }

    img,
    .magic-items-inline-icon {
        width: auto !important;
        height: ${({ theme }) => `calc(${theme.spacing.x4} + 1px)`};
        display: block;
        vertical-align: middle;
        margin-left: ${({ theme }) => `calc(-1 * ${theme.spacing.xxSmall})`};
    }
`;

export const AllAddedMessageBox = styled(Text)`
    flex: 1;
    color: ${({ theme }) => theme.colors[theme.colorMode].surprise_Deals_Primary};
    margin-bottom: ${({ theme }) => `calc(-1 * ${theme.spacing.xSmall})`};
`;
